import React, { useState } from 'react'
import { Box, Dialog, DialogContent, DialogActions } from '@mui/material'
import { Model, PartialAction, Position, State, StateObj } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { ConfirmDialog } from 'src/Components/Ui/ConfirmDialog'
import { useConfirm } from 'src/hooks/useConfirm'
import { ModelCard } from 'src/Components/Domain/ModelCard'
import { useModelSelector } from 'src/hooks/useModelSelector'
import { useRouter } from 'next/router'
import { getStartSimulationMessage } from 'src/logic'

const SET_BASE_MODEL = 'setBaseModel'
export const positionFilterLogic = (position: Position) => (m: Model) => m.position.includes(position)

type Props = {
  state: State
  models: Model[]
  kinds?: StateObj
  path?: string
  dispatch: React.Dispatch<PartialAction>
  filterLogic?: (m?: Model) => boolean
}

export const BaseModelSelector: React.FC<Props> = ({ state, models, kinds = { label: '硬式', value: 'hard' }, path, dispatch, filterLogic }) => {
  const { isEn, t } = useLocale()
  const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(true)
  const { isConfirmOpen, handleConfirmOpen, handleConfirmClose } = useConfirm()
  const [selectedModel, setSelectedModel] = useState<Model>()
  const message = getStartSimulationMessage(selectedModel, isEn, t)

  // 仕方がないので、ここで翻訳処理を行う
  // 本当に不本意。fuckって感じ
  const hardEn = { label: 'Hard', value: 'hard' }
  const softEn = { label: 'Soft', value: 'soft' }
  const isHard = kinds?.value === 'hard'
  const translatedKinds = isEn ? (isHard ? hardEn : softEn) : kinds
  const handleStartSimulation = () => {
    dispatch({ type: SET_BASE_MODEL, baseModel: selectedModel, kinds: translatedKinds })
    setIsDialogOpen(false)
    handleConfirmClose()
  }
  const router = useRouter()
  const urls = path ? path.split('/') : router.asPath.split('/')
  const { position, isReset } = useModelSelector(state, urls)
  const modelFilter = filterLogic ? filterLogic : positionFilterLogic(position)
  return (
    <Box>
      <Dialog open={isDialogOpen || isReset} maxWidth={'lg'}>
        <DialogContent>
          <Box position={'sticky'} left={0}>
            {t.PLEASE_SELECT_MODEL}
          </Box>
          <Box display={'flex'}>
            {models.filter(modelFilter).map((model) => (
              <ModelCard {...{ selectedModel, model, setSelectedModel }} key={model.productNumber} />
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <ConfirmDialog
            isConfirmOpen={isConfirmOpen}
            openButtonLabel={t.START_SIMULATION}
            dialogMessage={message}
            color={'primary'}
            variant={'contained'}
            handleOkButton={handleConfirmOpen}
            handleCancelButton={handleConfirmClose}
            handleExecuteButton={handleStartSimulation}
            disabled={!selectedModel}
          />
        </DialogActions>
      </Dialog>
    </Box>
  )
}
